"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Enum class DefinedMediaType.
* @enum {}
* @readonly
*/
class DefinedMediaType {
  constructor() {
    /**
     * value: "Any"
     * @const
     */
    _defineProperty(this, "Any", "Any");
    /**
     * value: "Audio"
     * @const
     */
    _defineProperty(this, "Audio", "Audio");
    /**
     * value: "Video"
     * @const
     */
    _defineProperty(this, "Video", "Video");
    /**
     * value: "Presentation"
     * @const
     */
    _defineProperty(this, "Presentation", "Presentation");
  }
  /**
  * Returns a <code>DefinedMediaType</code> enum value from a Javascript object name.
  * @param {Object} data The plain JavaScript object containing the name of the enum value.
  * @return {module:model/DefinedMediaType} The enum <code>DefinedMediaType</code> value.
  */
  static constructFromObject(object) {
    return object;
  }
}
exports.default = DefinedMediaType;